import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';
import {
  MultiSelectDropdown,
  Select,
  tokens,
} from '@sunrun/experience-ui-components';

const PerformanceWidgetSelectPortalStyles = () => (
  <Global
    // Overriding portal dropdown min width to 120px for leaderboard filters
    styles={css`
      ul.sr-option-list[style*='position: fixed'] {
        min-width: 120px !important;
        width: max-content !important;
        max-width: calc(100vw - 24px) !important;

        .sr-option {
          font-weight: 400;
        }
      }
    `}
  />
);

const pillTriggerStyles = `
  align-self: flex-end;

  .sr-select-container {
    display: flex;
    flex-direction: row-reverse;
    width: auto;

    > button.sr-button {
      width: auto;
      padding: 4px 12px;
      font-size: 12px;
      font-weight: 400;
      line-height: 140%;
      border-radius: 100px;
      border: 1px solid ${tokens.BRAND_HERO_BLUE};
      background: rgba(255, 255, 255, 0.1);
      color: ${tokens.BRAND_HERO_BLUE};

      span {
        margin: 0;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        font-weight: 400;
        line-height: 140%;
        color: inherit;
      }
    }
  }
  .sr-select-container.disabled-select {
    > button.sr-button {
      opacity: 0.5 !important;
      cursor: not-allowed;
    }
  }
  .sr-select-container svg {
    margin: 0;
    color: black !important;
    fill: black !important;
    stroke: black !important;
    width: 10px !important;
    height: 12px !important;
    path {
      fill: black !important;
      stroke: black !important;
    }
  }
`;

const PerformanceWidgetSelect = styled(Select)`
  min-width: 80px;
  max-width: 120px;
  ${pillTriggerStyles}

  .sr-select-container ul {
    min-width: 110px;
  }
`;

const PerformanceWidgetMultiSelect = styled(MultiSelectDropdown)`
  ${pillTriggerStyles}
`;

export {
  PerformanceWidgetMultiSelect,
  PerformanceWidgetSelect,
  PerformanceWidgetSelectPortalStyles,
};
